module.exports = __webpack_public_path__ + "img/9788963010724.855065d2.jpg";